const isProd = process.env.NODE_ENV === "production";

export const apiLink = isProd ? "https://pnbback1.eastea.in/" : "http://3.109.202.113:3000/";
